/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {intersection} from 'ramda';
import {isArray, isString} from 'ramda-adjunct';

import {quickFiltersConst} from '../constants/quickFilters';

/**
 * Quick-filter chip value derivation, extracted from the 13 filter components.
 *
 * Two variants preserve the exact return shapes the call sites depend on:
 * - getQuickFilterFromString: `string[] | null`.
 * - getQuickFilterFromIntersection: `string[]`.
 *
 * Plain functions (no React hooks) so they are exempt from rules-of-hooks and
 * React Compiler ref/effect lint; the `get` prefix follows getActions/getSortModel.
 */
export function getQuickFilterFromString(model: unknown): string[] | null {
  return isString(model) ? [model] : null;
}

export function getQuickFilterFromIntersection(model: unknown): string[] {
  const candidates = (isArray(model) ? model : [model]) as string[];
  return intersection(candidates, quickFiltersConst);
}
